// ============================================
// Chat Module - Model Selector (ES6)
// 모델 선택 바텀시트 관리
// ============================================

import { CHAT_ENDPOINTS } from '../shared/api-endpoints.js';
import { authFetch } from '../shared/auth-fetch.js';
import { getCurrentUser, getCurrentRoomId, getCurrentSessionId } from '../app/state.js';
import { showGlobalLoading, hideGlobalLoading } from '../utils.js';
import { getSelectedModel, setSelectedModel } from '../settings/state.js';
import { getModelOptions } from '../config.js';

// ============================================
// 모델 이름 가져오기
// ============================================

export function getModelDisplayName(modelId) {
  const model = getModelOptions().find(m => m.id === modelId);
  return model ? model.name : '호라이즌';
}

// ============================================
// UI 업데이트
// ============================================

export function updateModelNameDisplay() {
  const currentModel = getSelectedModel();
  const displayName = getModelDisplayName(currentModel);
  const nameEl = document.getElementById('currentModelName');
  if (nameEl) {
    nameEl.textContent = displayName;
  }
}

// ============================================
// 바텀시트 열기/닫기
// ============================================

export function openModelSelector() {
  const sheet = document.getElementById('modelSelectorSheet');
  if (!sheet) return;

  const content = document.getElementById('modelSelectorContent');
  const currentModel = getSelectedModel();
  const modelOptions = getModelOptions();

  content.innerHTML = modelOptions.map(model => `
    <div class="model-option ${model.id === currentModel ? 'selected' : ''}"
         data-action="selectModel" data-model="${model.id}">
      <div class="model-option-info">
        <div class="model-option-name">${model.name}</div>
        <div class="model-option-desc">${model.description}</div>
      </div>
      <div class="model-option-carbon${model.carbon === 0 ? ' free' : ''}">
        ${model.carbon === 0 ? '무료' : `<svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="10"/></svg>${model.carbon}`}
      </div>
      <svg class="model-option-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
    </div>
  `).join('');

  // 이벤트 위임
  content.addEventListener('click', (e) => {
    const option = e.target.closest('[data-action="selectModel"]');
    if (option) {
      selectModel(option.dataset.model);
    }
  });

  sheet.classList.add('open');
  if (window.ModalManager) {
    window.ModalManager.push('modelSelectorSheet');
  }
}

export function closeModelSelector() {
  const sheet = document.getElementById('modelSelectorSheet');
  if (sheet) {
    sheet.classList.remove('open');
  }
  if (window.ModalManager) {
    window.ModalManager.remove('modelSelectorSheet', true);
  }
}

// ============================================
// 모델 선택
// ============================================

export async function selectModel(modelId) {
  const currentModel = getSelectedModel();
  if (modelId === currentModel) {
    closeModelSelector();
    return;
  }

  closeModelSelector();

  const roomId = getCurrentRoomId();
  const sessionId = getCurrentSessionId();
  const user = getCurrentUser();
  if (roomId && sessionId && user) {
    showGlobalLoading();
    try {
      const response = await authFetch(CHAT_ENDPOINTS.updateChatSettings, {
        body: {
          roomId: roomId,
          sessionId: sessionId,
          updates: {
            settings: {
              model: modelId
            }
          }
        }
      });

      if (!response.ok) throw new Error('서버 오류');

      setSelectedModel(modelId);
      updateModelNameDisplay();

      if (window.currentChatData && window.currentChatData.settings) {
        window.currentChatData.settings.model = modelId;
      }
    } catch (err) {
      console.error('모델 설정 저장 실패:', err);
    } finally {
      hideGlobalLoading();
    }
  }
}

// ============================================
// window 노출 제거됨 (2026-01-06)
// 모든 호출이 ES6 import로 처리됨
// ============================================
